<template>
  <div
    :class="{
      'error-message': props.type === 'error',
      'info-message': props.type === 'info',
      'default-message': props.type === 'default',
    }"
  >
    <InfoIcon v-if="['error', 'info'].includes(type)" class="icon-smaller icon-error icon-info" />
    <p class="small">{{ message }}</p>
  </div>
</template>

<script setup lang="ts">
import InfoIcon from '@/components/icons/IconInfo.vue';

const props = withDefaults(
  defineProps<{
    type?: 'default' | 'error' | 'info';
    message: string;
  }>(),
  {
    type: 'default',
    message: '',
  }
);
</script>

<style scoped lang="scss">
.default-message {
  position: relative;
  display: flex;
  width: fit-content;
  align-self: center;
  max-width: 25rem;
  padding: 0.25rem 0.75rem;
  gap: 0.25rem;
  margin: 0 1rem 0.75rem 1rem;
  text-align: center;
  background-color: var(--surface-gray-dimmest);
  outline: 1px solid var(--border-dim);
  border-radius: 16px;

  p {
    color: $color-gray-200;
  }
}

.error-message {
  position: relative;
  display: flex;
  width: fit-content;
  align-self: center;
  align-items: flex-start;
  max-width: 25rem;
  padding: 0.25rem 0.75rem;
  gap: 0.25rem;
  margin: 0 1rem 0.75rem 1rem;
  text-align: left;
  background-color: var(--surface-error);
  border: 1px solid var(--border-error);
  border-radius: 8px;

  p {
    font-size: $font-size-psmall;
  }
}

.icon-info {
  position: relative;
  top: 0.125rem;
  flex-shrink: 0;
}
</style>
